import moment from "moment";
import { FC, useContext } from "react";
import {
  Badge,
  BadgeSize,
  BadgeVariant,
  Button,
  ButtonSize
} from "shared/components";
import { Check } from "untitledui-js-base";
import { getLogoSrc } from "utils/getLogoSrc";
import { ApplicationStatus, VerificationNames } from "shared/types";
import { PrintAllContext } from "views/applications-id-report/providers/PrintProvider";

type ReportHeaderProps = {
  title: string;
  name?: VerificationNames;
  reportDate?: Date | string;
  successLabel?: boolean;
  secondaryText?: string;
  applicationStatus?: ApplicationStatus;
  onCancelClick?: () => void;
  verificationId: number[] | number;
  printDisabled?: boolean;
  printButtonTitle?: string;
  // LOL
  idsWhichMayHaveFiles?: number[];
};

export const ReportHeader: FC<ReportHeaderProps> = ({
  title,
  name,
  reportDate,
  successLabel,
  secondaryText,
  verificationId,
  printButtonTitle,
  // printDisabled = false,
  idsWhichMayHaveFiles
}) => {
  const { setDocumentPrintingState, setPrintVerificationsState } =
    useContext(PrintAllContext);

  return (
    <div className="mb-4 flex justify-between gap-1 flex-col md:flex-row print:flex-col">
      <div className="flex items-center">
        <h1 className="flex items-center gap-4 text-xl font-bold text-content-1000">
          <p>
            {title}{" "}
            {secondaryText ? (
              <span className="text-content-100">{secondaryText}</span>
            ) : null}
          </p>

          {getLogoSrc(name as VerificationNames) && (
            <img
              className="mr-2"
              src={getLogoSrc(name as VerificationNames)}
              alt="logo"
            />
          )}

          {successLabel ? (
            <Badge
              className="ml-2 items-center"
              variant={BadgeVariant.SUCCESS}
              size={BadgeSize.BASE}
              leftElement={<Check size="12px" className="stroke-success-600" />}
            >
              Passed
            </Badge>
          ) : null}
        </h1>
      </div>
      <div className="flex items-center gap-4">
        {reportDate && moment(reportDate).isValid() ? (
          <p className="text-xs text-content-400">
            Report date: {moment(reportDate).format("MMM DD, YYYY")}
          </p>
        ) : null}
        <div className="no-print shrink-0 flex gap-2 items-center">
          <Button
            className="print:hidden hidden md:flex"
            onClick={() => {
              if (!verificationId) return;
              if (Array.isArray(verificationId)) {
                setDocumentPrintingState(
                  name === VerificationNames.HousingHistory ||
                    title === "Income report"
                    ? verificationId.reduce(
                        (acc, v) => {
                          if (idsWhichMayHaveFiles?.includes(v))
                            acc.push({ status: "loading", reportId: v });
                          else acc.push({ status: "ready", reportId: v });

                          return acc;
                        },
                        [] as {
                          status: "loading" | "ready" | "error";
                          reportId: number;
                          numDocuments?: number | undefined;
                        }[]
                      )
                    : verificationId.map((v) => ({
                        status: "ready",
                        reportId: v
                      }))
                );
                const pws = verificationId.reduce((acc, key) => {
                  acc[key] = false;
                  return acc;
                }, {});
                setPrintVerificationsState(pws);
              } else {
                setDocumentPrintingState([
                  {
                    status:
                      name === VerificationNames.HousingHistory ||
                      title === "Income report"
                        ? "loading"
                        : "ready",
                    reportId: verificationId
                  }
                ]);
                setPrintVerificationsState({
                  [verificationId]: false
                });
              }
            }}
            size={ButtonSize.SM}
          >
            {printButtonTitle ?? "Print report"}
          </Button>
        </div>
      </div>
    </div>
  );
};
